import type { Scheduling } from '@src/core/buyerApiClient';

export type ScheduleDatesByKey = {
  [date: string]: {
    availables: Scheduling[];
    unavailables: Scheduling[];
  };
};

export const toScheduleDayKey = (date: string): string => date.slice(0, 10);

export function resolveSchedulingsForDate(
  dates: ScheduleDatesByKey | undefined,
  selectedDate: string | undefined,
): ScheduleDatesByKey[string] | undefined {
  if (!dates || !selectedDate) {
    return undefined;
  }

  const exactMatch = dates[selectedDate];
  if (exactMatch) {
    return exactMatch;
  }

  const dayKey = toScheduleDayKey(selectedDate);
  const matchingKeys = Object.keys(dates).filter((key) => toScheduleDayKey(key) === dayKey);
  if (!matchingKeys.length) {
    return undefined;
  }

  return matchingKeys.reduce(
    (acc, key) => ({
      availables: [...acc.availables, ...(dates[key]?.availables ?? [])],
      unavailables: [...acc.unavailables, ...(dates[key]?.unavailables ?? [])],
    }),
    { availables: [] as Scheduling[], unavailables: [] as Scheduling[] },
  );
}
